export default __webpack_public_path__ + "static/media/star-world.3a6ebab2.png";